// @flow
import styled from "styled-components"
import { Wrap } from "componentsStyled/Layout/Wrap"


export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3rem;

  justify-content: space-between;
  height: 65rem;

  form {
    width: 100%;
  }

  * {
    box-shadow: none;
  }
`

export const StyledWrap = styled(Wrap)`
  display: flex;
  flex-direction: column;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/modals/SubscribePlanConfirmation/styled.js